import { render } from "./pre-popup.vue?vue&type=template&id=31dfeb74&scoped=true"
import script from "./pre-popup.vue?vue&type=script&lang=js"
export * from "./pre-popup.vue?vue&type=script&lang=js"

import "./pre-popup.vue?vue&type=style&index=0&id=31dfeb74&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dfeb74"]])

export default __exports__